import { types } from 'mobx-state-tree';

export const RoadSignRegulationModel = types.model('RoadSignRegulationModel', {
  code: types.maybe(types.integer),
  comment: types.maybe(types.string)
});
